<header-web (dataEvent)='setLanguage($event)'></header-web>
<h1>NOSOTROS</h1>
<footer-web></footer-web>